import React, { useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import { formatDate } from "../../../../common/Validations";

const PrintInvoice = React.forwardRef(({ data, onsendinvoicedata }, ref) => {
  // const appConfig = useSelector((state) => state?.app?.appConfig); // Application Details from Store

  const tableStyle = {
    border: "1px solid black",
    borderCollapse: "collapse",
    padding: "4px",
  };

  // const printbody = {
  //   display: "flex",
  //   flexDirection: "column",
  //   minHeight: "297mm", // A4 height
  //   padding: "4px",
  //   margin: "0", // Center on print page
  //   backgroundColor: "#fff",
  //   boxSizing: "border-box",
  // };
  const printbody = {
    display: "flex",
    flexDirection: "column",
    width: "297mm", // A3 width (portrait)
    minHeight: "420mm", // A3 height
    padding: "4px",
    margin: "0 auto", // This is the key to horizontal centering
    backgroundColor: "#fff",
    boxSizing: "border-box",
  };

  //nuber to words conversion
  const convertNumberToWords = (amount) => {
    if (amount === "" || isNaN(amount)) return "";
    let num = parseFloat(amount).toFixed(2); // Ensure 2 decimal places

    let [rupees, paise] = num.split(".");
    rupees = parseInt(rupees);
    paise = parseInt(paise);

    const ones = [
      "",
      "One",
      "Two",
      "Three",
      "Four",
      "Five",
      "Six",
      "Seven",
      "Eight",
      "Nine",
      "Ten",
      "Eleven",
      "Twelve",
      "Thirteen",
      "Fourteen",
      "Fifteen",
      "Sixteen",
      "Seventeen",
      "Eighteen",
      "Nineteen",
    ];

    const tens = [
      "",
      "",
      "Twenty",
      "Thirty",
      "Forty",
      "Fifty",
      "Sixty",
      "Seventy",
      "Eighty",
      "Ninety",
    ];

    const scales = ["", "Thousand", "Million", "Billion", "Trillion"];

    const convertBelowThousand = (n) => {
      if (n < 20) return ones[n];
      if (n < 100)
        return (
          tens[Math.floor(n / 10)] + (n % 10 !== 0 ? " " + ones[n % 10] : "")
        );
      return (
        ones[Math.floor(n / 100)] +
        " Hundred" +
        (n % 100 !== 0 ? " " + convertBelowThousand(n % 100) : "")
      );
    };

    let words = "";
    let scaleIndex = 0;

    while (rupees > 0) {
      let part = rupees % 1000;
      if (part !== 0) {
        words =
          convertBelowThousand(part) +
          " " +
          scales[scaleIndex] +
          (words ? " " + words : "");
      }
      rupees = Math.floor(rupees / 1000);
      scaleIndex++;
    }

    words = words.trim() ? words.trim() + " Rupees" : "";

    if (paise > 0) {
      let paiseWords = convertBelowThousand(paise) + " Paise";
      words += " and " + paiseWords;
    }

    return words || "Zero Rupees";
  };

  //total tax amount
  const totalTaxAmount = data?.items?.reduce((acc, item) => {
    const cgstvalue = parseFloat(item?.cgstValue) || 0;
    const sgstvalue = parseFloat(item?.sgstValue) || 0;
    return acc + cgstvalue + sgstvalue;
  }, 0);

  // const sgstItem14 = data?.items?.find((item) => item?.sgst === 14);
  // const sgstItem9 = data?.items?.find((item) => item?.sgst === 9);
  const sgstItem14 = data?.items?.find(
    (item) =>
      item?.sgst === 14 && item?.sgstValue !== 0 && item?.cgstValue !== 0
  );

  const sgstItem9 = data?.items?.find(
    (item) => item?.sgst === 9 && item?.sgstValue !== 0 && item?.cgstValue !== 0
  );

  //IGST
  const igstItems = data?.items?.filter(
    (item) =>
      item?.isIGST === true && item?.sgstValue === 0 && item?.cgstValue === 0
  );
  const totalGst = data?.items?.reduce((sum, item) => sum + item.gstValue, 0);

  /* 14 total sgst cgst */
  const totalSgst14 = data?.items
    ?.filter((item) => item?.sgst === 14)
    ?.reduce((acc, item) => acc + Number(item?.sgstValue || 0), 0)
    .toFixed(2);
  const totalCgst14 = data?.items
    ?.filter((item) => item?.cgst === 14)
    ?.reduce((acc, item) => acc + Number(item?.cgstValue || 0), 0)
    .toFixed(2);

  const totstGst14 = parseFloat(totalSgst14) + parseFloat(totalCgst14);

  /* 9 total sgst cgst */
  const totalSgst9 = data?.items
    ?.filter((item) => item?.sgst === 9)
    ?.reduce((acc, item) => acc + Number(item?.sgstValue || 0), 0)
    .toFixed(2);
  const totalCgst9 = data?.items
    ?.filter((item) => item?.cgst === 9)
    ?.reduce((acc, item) => acc + Number(item?.cgstValue || 0), 0)
    .toFixed(2);
  const totstGst9 = parseFloat(totalSgst9) + parseFloat(totalCgst9);

  //total Basic Amount
  const totalBasic = data?.items.reduce(
    (sum, item) => sum + Number(item.basicAmount || 0),
    0
  );

  const totalNetValueRaw =
    parseFloat(totstGst14) + parseFloat(totstGst9) + parseFloat(totalBasic);
  const totalNetValue = parseFloat(totalNetValueRaw.toFixed(2));

  const rounded = Math.round(totalNetValue); // Nearest whole number
  const difference = (rounded - totalNetValue).toFixed(2); // Difference with sign
  const displayValue = rounded.toFixed(2); // Always shows ".00"

  const totalAmountInwords = convertNumberToWords(displayValue);
  const totalTaxAmountinwords = convertNumberToWords(totalTaxAmount);
  //igst totalamount
  const totalIgstAmountInwords = convertNumberToWords(
    data?.totals?.totalNetValue
  );

  const totalBags = data?.items?.reduce((acc, item) => {
    return item?.uOM === "BAGS"
      ? acc + Number(item?.orderQtyLoadConfirm || 0)
      : acc;
  }, 0);

  const totalLtr = data?.items?.reduce((acc, item) => {
    return item?.uOM === "LTR"
      ? acc + Number(item?.orderQtyLoadConfirm || 0)
      : acc;
  }, 0);
  // Prepare data
  const invoiceData = {
    difference,
    rounded,
    // ... add others
  };

  // Send to parent when ready (e.g., on mount or a button click)
  useEffect(() => {
    if (onsendinvoicedata) {
      onsendinvoicedata(invoiceData);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [onsendinvoicedata]);

  return (
    <div ref={ref} style={printbody} className="m-4">
      <p className="text-center fs-4 fw-bold">TAX INVOICE {/* {data} */}</p>
      <Row>
        <Col xs={12} md={12} lg={12} className="d-flex"></Col>

        <Col xs={12} md={12} lg={12} className="d-flex">
          <Col xs={1} md={1} lg={1}>
            <p className="fs-5 mb-0 text-nowrap">Ack Date</p>
          </Col>
          <Col xs={10} md={10} lg={10}>
            <p className="fs-5 fw-bold me-4 mb-0">
              : {formatDate(data?.createdAt)}
            </p>
          </Col>
        </Col>
      </Row>

      {/* table-01 */}
      <table className="w-100" style={tableStyle}>
        {/* row-1 */}
        <tr style={tableStyle}>
          <td rowSpan={3} className="w-50" style={tableStyle}>
            <span className="fw-bold">{data?.companyCodeDesc}</span>
            <p className="mb-0">{data?.companyAddress}</p>
            {data?.companyCertifications && data?.companyCertifications[0] && (
              <p className="mb-0">
                GSTIN/UIN : {data?.companyCertifications[0]?.documentNumber}
              </p>
            )}

            <span>State Name : Karnataka, Code : 29</span>

            <br />
            <span>
              Contact :{" "}
              <span>
                {data?.companyContact && (
                  <>
                    <span>{data?.companyContact[0]?.contant1}/</span>
                    <span> {data?.companyContact[1]?.contant2}</span>
                  </>
                )}
              </span>
            </span>
          </td>
          <td className="w-25" style={tableStyle}>
            <Row>
              <Col lg={6} className="d-flex flex-column">
                <span>Invoice No.</span>
                <span className="fw-bold">{data?.documentNumber}</span>
              </Col>
              {data?.e_WayBillNo && (
                <Col lg={6} className="d-flex flex-column">
                  <span> e-Way Bill No.</span>
                  <span className="fw-bold">{data?.e_WayBillNo}</span>
                </Col>
              )}
            </Row>
          </td>
          <td style={tableStyle}>
            {" "}
            Dated<p className="m-0 fw-bold">
              {formatDate(data?.createdAt)}
            </p>{" "}
          </td>
        </tr>
        <tr>
          <td style={tableStyle}>Delivery Note</td>
          <td style={tableStyle}>Mode/Terms of Payment</td>
        </tr>
        <tr>
          <td style={tableStyle}>Buyer's Order No.</td>
          <td style={tableStyle}>Dated</td>
        </tr>
        {/* row-2 */}
        <tr style={tableStyle}>
          <td rowSpan={3} className="w-50" style={tableStyle}>
            <p className="m-0">Consignee (Ship to)</p>
            <span className="fw-bold">{data?.customerName}</span>
            <br />
            <span className="text-lg mb-0">
              {data?.items ? data?.items[0]?.shippingAddress + " " : ""}
              {data?.items ? data?.items[0]?.shippingPostalCode : ""}
            </span>
            {/* <span>{data?.items[0]?.customerAddress}</span> */}
            <br />
            {data?.items &&
              data?.items[0] &&
              data?.items[0]?.certifications &&
              data?.items[0]?.certifications[0] && (
                <p className="mb-0">
                  GSTIN/UIN :{" "}
                  {data?.items[0]?.certifications[0]?.documentNumber}
                </p>
              )}
            <span>State Name : Karnataka, Code : 29</span>
            <br />

            <br />
          </td>
          <td style={tableStyle}> Dispatch Doc No</td>
          <td style={tableStyle}> Delivery Note Date</td>
        </tr>
        <tr>
          <td style={tableStyle}>Dispatched through</td>
          <td style={tableStyle}>Destination</td>
        </tr>
        <tr>
          <td style={tableStyle}>Bill of Lading/LR-RR No</td>
          <td style={tableStyle}>
            Motor Vehicle No.{" "}
            {!!data?.items[0]?.loadingOtherTruckNo ? (
              <p className="fw-bold">
                {data?.items[0]?.loadingOtherTruckNo.toUpperCase()}
              </p>
            ) : (
              <p className="fw-bold">
                {data?.items[0]?.loadingTruckNoDescription}
              </p>
            )}
          </td>
        </tr>
        {/*  row-3*/}
        <tr style={tableStyle}>
          <td className="w-50" style={tableStyle}>
            <p className="m-0">Buyer (Bill to)</p>
            <span className="fw-bold">{data?.customerName}</span>
            <br />
            <span>{data?.items[0]?.customerAddress}</span>
            <br />
            <span>State Name : Karnataka, Code : 29</span>
            <br />
            {data?.items &&
              data?.items[0] &&
              data?.items[0]?.certifications &&
              data?.items[0]?.certifications[0] && (
                <p className="mb-0">
                  GSTIN/UIN :{" "}
                  {data?.items[0]?.certifications[0]?.documentNumber}
                </p>
              )}
            <span> Place of Supply : Karnataka</span>
          </td>
          <td colspan={2} className="d-flex">
            Terms of Delivery
          </td>
        </tr>
      </table>

      {/* table 2 */}

      <table
        style={{ marginTop: "16px", width: "100%", borderCollapse: "collapse" }}
      >
        {/* ---------------------------------------- */}
        <table
          className="w-100"
          style={{ ...tableStyle, tableLayout: "fixed" }}
        >
          <tr style={tableStyle}>
            <td
              style={{
                width: "60px",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                fontSize: "12px",
              }}
            >
              Sl.No.
            </td>
            <td style={tableStyle} className="w-25">
              Description of Goods
            </td>
            <td style={tableStyle}>HSN/SAC</td>
            <td style={tableStyle}>Quantity</td>
            <td style={tableStyle}>Rate</td>
            <td style={tableStyle}>Per</td>
            <td style={tableStyle}>Disc.%</td>
            <td style={tableStyle}>Basic</td>
          </tr>

          {/* ======== map items ============= */}
          {data?.items?.map((item, i) => (
            <tr key={i} style={tableStyle}>
              <td
                style={{
                  width: "60px",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  fontSize: "12px",
                }}
              >
                {i + 1}.
              </td>
              <td style={tableStyle}>
                <Row>
                  <Col xs={6} md={6} lg={6} className="fw-bold">
                    {item?.materialDescription}
                  </Col>
                  <Col xs={6} md={6} lg={6}>
                    {item?.exWork && item?.exWork === "Ex-Work" ? (
                      <span>{item?.exWork}</span>
                    ) : (
                      ""
                    )}
                  </Col>
                </Row>
              </td>
              <td style={tableStyle}>{item?.materialCode}</td>
              <td style={tableStyle} className="fw-bold">
                {item?.orderQtyLoadConfirm}{" "}
                {item?.uOM === "LTR" ? "Nos" : item?.uOM}
              </td>
              <td style={tableStyle} className="text-end">
                {item?.basicPrice}
              </td>
              <td style={tableStyle}>
                {item?.uOM === "LTR" ? "Nos." : item?.uOM}
              </td>
              <td style={tableStyle}>--</td>
              <td style={tableStyle} className="fw-bold text-end">
                {Number(item?.basicAmount).toFixed(2)}
              </td>
            </tr>
          ))}
          {/* --------------------Ex- works------------ */}
          {/* <tr style={tableStyle}>
            <td style={tableStyle}></td>
            <td style={tableStyle}>Ex-Works</td>
            <td style={tableStyle}></td>
            <td style={tableStyle}></td>
            <td style={tableStyle}></td>
            <td style={tableStyle}></td>
            <td style={tableStyle}></td>
            <td style={tableStyle} className="fw-bold text-end">
            </td>
          </tr> */}
          {/* ======== Total Amount Row ============= */}
          {/* ------------14%--------------- */}
          {sgstItem14 && (
            <>
              <tr style={tableStyle}>
                <td style={tableStyle}></td>
                <td style={tableStyle} className="fw-bold text-end">
                  Output S GST @ 14%
                </td>
                <td style={tableStyle}></td>
                <td style={tableStyle}></td>
                <td style={tableStyle} className="text-end">
                  14
                </td>
                <td style={tableStyle}>%</td>
                <td style={tableStyle}></td>
                <td style={tableStyle} className="fw-bold text-end">
                  {/* {parseFloat(item?.gstValue)} */}
                  {totalSgst14}
                </td>
              </tr>
              <tr style={tableStyle}>
                <td style={tableStyle}></td>
                <td style={tableStyle} className="fw-bold text-end">
                  Output C GST @ 14%
                </td>
                <td style={tableStyle}></td>
                <td style={tableStyle}></td>
                <td style={tableStyle} className="text-end">
                  14
                </td>
                <td style={tableStyle}>%</td>
                <td style={tableStyle}></td>
                <td style={tableStyle} className="fw-bold text-end">
                  {totalCgst14}
                </td>
              </tr>
            </>
          )}
          {/* ------------9%--------------- */}
          {sgstItem9 && (
            <>
              <tr style={tableStyle}>
                <td style={tableStyle}></td>
                <td style={tableStyle} className="fw-bold text-end">
                  Output S GST @ 9%
                </td>
                <td style={tableStyle}></td>
                <td style={tableStyle}></td>
                <td style={tableStyle} className="text-end">
                  9
                </td>
                <td style={tableStyle}>%</td>
                <td style={tableStyle}></td>
                <td style={tableStyle} className="fw-bold text-end">
                  {/* {parseFloat(item?.gstValue)} */}
                  {totalSgst9}
                </td>
              </tr>
              <tr style={tableStyle}>
                <td style={tableStyle}></td>
                <td style={tableStyle} className="fw-bold text-end">
                  Output C GST @ 9%
                </td>
                <td style={tableStyle}></td>
                <td style={tableStyle}></td>
                <td style={tableStyle} className="text-end">
                  9
                </td>
                <td style={tableStyle}>%</td>
                <td style={tableStyle}></td>
                <td style={tableStyle} className="fw-bold text-end">
                  {totalCgst9}
                </td>
              </tr>
            </>
          )}

          {/* ============= IGST ===================== */}
          {igstItems && igstItems?.length > 0 && (
            <>
              <tr style={tableStyle}>
                <td style={tableStyle}></td>
                <td style={tableStyle} className="fw-bold text-end">
                  Output IGST @ {igstItems[0]?.igstPercent}%
                </td>
                <td style={tableStyle}></td>
                <td style={tableStyle}></td>
                <td style={tableStyle} className="text-end">
                  {igstItems[0]?.igstPercent}
                </td>
                <td style={tableStyle}>%</td>
                <td style={tableStyle}></td>
                <td style={tableStyle} className="fw-bold text-end">
                  {/* {parseFloat(item?.gstValue)} */}
                  {totalGst}
                </td>
              </tr>
              {/* <tr style={tableStyle}>
                <td style={tableStyle}></td>
                <td style={tableStyle} className="fw-bold text-end">
                  Output C GST @ 14%
                </td>
                <td style={tableStyle}></td>
                <td style={tableStyle}></td>
                <td style={tableStyle} className="text-end">
                  14
                </td>
                <td style={tableStyle}>%</td>
                <td style={tableStyle}></td>
                <td style={tableStyle} className="fw-bold text-end">
                  {totalCgst14}
                </td>
              </tr> */}
            </>
          )}

          {/* =============round of ===================== */}
          {difference !== "0.00" && (
            <tr style={tableStyle}>
              <td style={tableStyle}></td>
              <td style={tableStyle}>Round Off</td>
              <td style={tableStyle}></td>
              <td style={tableStyle}></td>
              <td style={tableStyle}></td>
              <td style={tableStyle}></td>
              <td style={tableStyle}></td>
              <td style={tableStyle} className="fw-bold text-end">
                {data?.items[0]?.isIGST === true ? data?.roundOff : difference}
              </td>
            </tr>
          )}

          {/* ======== Final Total ============= */}
          <tr style={tableStyle}>
            <td style={tableStyle}></td>
            <td style={tableStyle}>Total</td>
            <td style={tableStyle}></td>
            <td style={tableStyle} className="fw-bold">
              {totalBags && <span>{totalBags} BAGS</span>}
              {/* {totalLtr && totalLtr !== 0 && <span>,{totalLtr} Nos</span>} */}
              {Number(totalLtr) > 0 && <span>,{totalLtr} Nos</span>}
            </td>
            <td style={tableStyle}></td>
            <td style={tableStyle}></td>
            <td style={tableStyle}></td>
            <td style={tableStyle} className="fw-bold text-end">
              &#8377;
              {/* {displayValue}    */}
              {data?.items[0]?.isIGST === true
                ? data?.totals?.totalNetValue
                : displayValue}
            </td>
          </tr>

          {/* ======== Amount in words ============= */}
          <tr>
            <td className="m-0 text-nowrap">Amount Chargeable (in words)</td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td>E. & O.E</td>
          </tr>
          <tr>
            <td className="fw-bold">
              <p className="m-0 text-nowrap">
                <span>INR </span>
                {/* {totalAmountInwords} */}
                {data?.items[0]?.isIGST === true
                  ? totalIgstAmountInwords
                  : totalAmountInwords}
                <span> only</span>
              </p>
            </td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
        </table>

        {/* ---------------------------------------- */}

        {/* table3 */}
        <table className="w-100" style={tableStyle}>
          {(sgstItem14 || sgstItem9) && (
            <>
              <tr style={tableStyle}>
                <td style={tableStyle}>HSN/SAC</td>
                <td style={tableStyle}>Taxable Value</td>
                <td colSpan="2" style={tableStyle}>
                  CGST
                </td>
                <td colSpan="2" style={tableStyle}>
                  SGST/UTGST
                </td>
                <td style={tableStyle}>Total Tax Amount </td>
              </tr>

              <tr style={tableStyle}>
                <td style={tableStyle}></td>
                <td style={tableStyle}> </td>
                <td style={tableStyle}>Rate</td>
                <td style={tableStyle}>Amount</td>
                <td style={tableStyle}>Rate</td>
                <td style={tableStyle}>Amount</td>
                <td style={tableStyle}></td>
              </tr>
            </>
          )}

          {/* {igstItems && igstItems?.length > 0 && (
            <>
              <tr style={tableStyle}>
                <td style={tableStyle}>HSN/SAC</td>
                <td style={tableStyle}>Taxable Value</td>
                <td colSpan="2" style={tableStyle}>
                  IGST
                </td>
                <td style={tableStyle}>Total Tax Amount </td>
              </tr>
              <tr style={tableStyle}>
                <td style={tableStyle}></td>
                <td style={tableStyle}> </td>
                <td style={tableStyle}>Rate</td>
                <td style={tableStyle}>Amount</td>
              </tr>
            </>
          )} */}

          {/* IGST Header */}
          {igstItems && igstItems.length > 0 && (
            <>
              <tr style={tableStyle}>
                <td style={tableStyle}>HSN/SAC</td>
                <td style={tableStyle}>Taxable Value</td>
                <td colSpan="2" style={tableStyle}>
                  IGST
                </td>
                <td style={tableStyle}>Total Tax Amount</td>
              </tr>
              <tr style={tableStyle}>
                <td style={tableStyle}></td>
                <td style={tableStyle}></td>
                <td style={tableStyle}>Rate</td>
                <td style={tableStyle}>Amount</td>
                <td style={tableStyle}></td>
              </tr>
            </>
          )}

          {/* items maping */}
          {data?.items?.map((item, i) => (
            <>
              <tr key={i} style={tableStyle}>
                <td style={tableStyle} className="text-end">
                  {item?.materialCode}
                </td>
                <td style={tableStyle} className="text-end">
                  {item?.basicAmount}
                </td>
                <td style={tableStyle} className="text-end">
                  {item?.cgst}
                </td>
                <td style={tableStyle} className="text-end">
                  {item?.cgstValue}
                </td>
                <td style={tableStyle} className="text-end">
                  {item?.sgst}
                </td>
                <td style={tableStyle} className="text-end">
                  {item?.sgstValue}
                </td>
                <td style={tableStyle} className="text-end">
                  {parseFloat(item?.cgstValue) + parseFloat(item?.sgstValue)}
                </td>
              </tr>
            </>
          ))}

          {/* total */}
          <tr style={tableStyle}>
            <td style={tableStyle}>Total</td>
            <td style={tableStyle} className="fw-bold text-end">
              {data?.totals?.totalAmount}
            </td>
            <td style={tableStyle}></td>
            <td style={tableStyle} className="fw-bold text-end">
              {data?.totals?.totalCgst}
            </td>
            <td style={tableStyle}></td>
            <td style={tableStyle} className="fw-bold text-end">
              {data?.totals?.totalSgst}
            </td>
            <td style={tableStyle} className="fw-bold text-end">
              {parseFloat(totalTaxAmount?.toFixed(2))}
            </td>
          </tr>
        </table>
        {/* table4 */}
        <table className="w-100" style={tableStyle}>
          <tr style={tableStyle}>
            <td style={tableStyle}>
              <Row>
                <Col xs={12} md={12} lg={12} className="my-4">
                  <span className="me-2">Tax Amount (in words) :</span>
                  <span className="fw-bold text-nowrap">
                    INR {totalTaxAmountinwords} Only
                  </span>
                </Col>
                <Col xs={6} md={6} lg={6}>
                  <p className="m-0">
                    <span>Company's PAN :</span>
                    <span className="fw-bold">
                      {" "}
                      {data?.companyCertifications &&
                        data?.companyCertifications[1]?.certificateCode &&
                        data.companyCertifications[1]?.certificateCode}
                    </span>
                  </p>
                  <p className="m-0 text-decoration-underline">Declaration</p>
                  <p className="m-0 w-75">
                    We declare that this invoice shows the actual price of the
                    goods described and that all particulars are true and
                    correct.
                  </p>
                  <p className="m-0">
                    1.Goods once sold cannot be taken back or exchanged
                  </p>
                  <p className="m-0">
                    2.We are not responisble for Material Damaged in Transit.
                  </p>
                  <p className="m-0">
                    3.Payment should be made to our company as per agreed credit
                    period.
                  </p>
                </Col>
                <Col
                  xs={6}
                  md={6}
                  lg={6}
                  className="d-flex flex-column flex-nowrap"
                >
                  {data?.companyBankDetails && (
                    <div className="mb-4">
                      <span>Company's Bank Details</span>
                      <Row className="m-0 d-flex ">
                        <Col xs={4} md={4} lg={4}>
                          A/c Holder's Name :
                        </Col>
                        <Col
                          xs={8}
                          md={8}
                          lg={8}
                          className="fw-bold text-nowrap"
                        >
                          {data?.companyBankDetails[0]?.AccountHolderName}
                        </Col>
                        <Col xs={4} md={4} lg={4}>
                          Bank Name :
                        </Col>
                        <Col
                          xs={8}
                          md={8}
                          lg={8}
                          className="fw-bold text-nowrap"
                        >
                          {data?.companyBankDetails[0]?.bankAccountName}{" "}
                        </Col>
                        <Col xs={4} md={4} lg={4}>
                          A/c No.:
                        </Col>
                        <Col
                          xs={8}
                          md={8}
                          lg={8}
                          className="fw-bold text-nowrap"
                        >
                          {data?.companyBankDetails[0]?.bankAccountNumber}{" "}
                        </Col>
                        <Col xs={4} md={4} lg={4}>
                          Branch & IFS Code:
                        </Col>
                        <Col
                          xs={8}
                          md={8}
                          lg={8}
                          className="fw-bold text-nowrap"
                        >
                          {data?.companyBankDetails[0]?.bankKey}{" "}
                        </Col>
                        <Col xs={4} md={4} lg={4}>
                          SWIFT Code:
                        </Col>
                        <Col
                          xs={8}
                          md={8}
                          lg={8}
                          className="fw-bold text-nowrap"
                        >
                          {" "}
                        </Col>
                      </Row>
                    </div>
                  )}
                  <div className="d-flex flex-column align-items-end">
                    <p className="mb-4 fw-bold">For {data?.companyCodeDesc}</p>
                    <p className="mt-4 mb-0">Authorised Signatory</p>
                  </div>
                </Col>
              </Row>
            </td>
          </tr>
        </table>
      </table>
      <div className="text-center ">
        <p>SUBJECT TO BENGALURU JURISDICTION</p>
        <p>This is a Computer Generated Invoice</p>
      </div>
    </div>
  );
});

export default PrintInvoice;
